export default "__VITE_ASSET__CVxhI$Tl__"